// Lookup_CoachingEventStatus
export enum CoachingEventStatus {
    DRAFT = 1,
    PRE_APPROVAL,
    ACTIVE,
    PENDING_CLOSE,
    CLOSED,
    DELETED,

    /** should not be used. TODO revise. but maybe it should. this will be presented as draft but managed as disputed */
    DISPUTED,

    UPDATING,
}
